import { h } from 'preact';
import * as BaseComp from 'components/bolt/movieDetails/movieDetails.js';
import { findInVNode } from 'utils/vnode';
import { joinClasses, accessNested, sortObjectByOrder } from 'utils/utils';
import Button from 'components/bolt/button/button';
import HTML from 'components/core/html/html';
import Store from 'store/store';
import s from 'components/bolt/movieDetails/movieDetails.sss';

export default class MovieDetails extends BaseComp.default {

	renderButtons(buttons) {
		const { appData, copy, visible, hide, buttonLayout = 'row' } = this.props;
		const fontStyles = accessNested(appData, 'styling.fontVariables') || {};

		if (buttons && Object.keys(buttons).length) {
			let store = Store.get();
			return (
				<div class={joinClasses(s.buttons, visible && s.visible, hide && s.hide, s[buttonLayout])}>
					{sortObjectByOrder(buttons).map((button, index) => {
						if (!button) {
							return;
						}
						let page = appData.pages[button.path];
						if (!button.path.startsWith('@') && !page && !button.path.match(/^https?:\/\/|mailto/)) {
							return;
						}
						if (page?.ageRestricted && store.client?.ofAge === false) {
							return;
						}
						let label = copy.baseCopy[button.label] || button.label;
						const { conjoinedButton } = button;
						let conjoinedLabel;
						if (conjoinedButton) {
							conjoinedLabel = copy.baseCopy[conjoinedButton.label] || conjoinedButton.label;
						}

						return (
							<Button
								class={joinClasses(s.button, fontStyles.homeButtons, conjoinedButton && s.conjoined)}
								trigger={() => this.triggerButton(button.path, label, button.sameWindow)}
								type="floating"
								key={button.path + index}
								id={button.id && button.id}
								conjoined={button.conjoinedButton}
								conjoinedTrigger={() => conjoinedButton && this.triggerButton(conjoinedButton.path, conjoinedLabel, conjoinedButton.sameWindow)}
							>
								<HTML
									class={s.buttonLabel}
									markdown
									content={label}
								/>
							</Button>
						);
					})}
				</div>
			);
		}
	}

	renderAudibleLine(data) {
		const { text, logo, logoLink } = data;
		return (
			<div class={s.audibleLineContainer}>
				{logoLink && (
					<a href={logoLink} target="_blank">
					<span>{text}</span>
					<img src={logo} />
					</a>
				)}
				{!logoLink && <img src={logo} />}
			</div>
		);
	}

	render(props, state) {
		const hasUarHeader = props?.appData?.header?.uarHeader;
		const isDesktopSize = Store.get()?.client?.isDesktopSize;
		const audibleLineData = props?.appData?.pages?.boltHome?.data?.audibleLine || {};
		const hasAudibleLine = props.type === 'home' && audibleLineData.text;

		const base = super.render(props, state);
		
		if (hasAudibleLine) {
			const buttonsNode = findInVNode(base, `.${s.buttons}`);
			const detailsNode = findInVNode(base, `.${s.details}`);
			let buttonsClass = buttonsNode?.attributes?.class || '';
			buttonsClass += ` ${s.hasAudibleLine}`;
			buttonsNode.attributes.class = buttonsClass;
			const audibleLine = this.renderAudibleLine(audibleLineData);
			detailsNode?.children.push(audibleLine);
		}

		if (hasUarHeader) {
			let newTop;
			if (isDesktopSize) {
				newTop = '80px';
			} else {
				newTop = '64px';
			}
			if (newTop) {
				base.attributes.style = {
					...base.attributes.style,
					top: newTop
				};
				const nodeWithPositionBottom = findInVNode(base, `.${s.bottom}`);
				if (nodeWithPositionBottom) {
					nodeWithPositionBottom.attributes.style = {
						...nodeWithPositionBottom.attributes.style,
						bottom: `calc(${isDesktopSize ? '10%' : '48px'} + ${newTop})`
					};
				}
			}
		}
		return base;
	}
}
